module.exports = __webpack_public_path__ + "static/img/jiantou.faf405b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiantou.png
// module id = 93Nf
// module chunks = 16